'use client';

import dynamic from 'next/dynamic';
import type { AnimationAssetProps } from './animation-asset-factory';

export type { AnimationAssetProps };

export const AnimationAsset = dynamic(
    () => import('./animation-asset-factory').then((mod) => mod.AnimationAssetFactory),
    { ssr: false }
);
